export enum EmailAccessValidation {
    activeWithOneUserId = 'ACTIVE USER WITH ONE USER ID',
    activeWithMultipleUserId = 'ACTIVE USER MULTIPLE USER IDS',
    deactivatedUser = 'DEACTIVATED USER',
    userNotExist = 'USER DOES NOT EXIST',
}
